/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { withAuthenticationRequired } from "./Auth0";

export default withAuthenticationRequired(
  ({ children }: { children: React.ReactNode }) => <>{children}</>,
  {
    // TODO : here should be loader imported from GNUI
    // However I was not able to add GNUI to this project because of the node version mismatch
    onRedirecting: () => <div />,
    loginOptions: {
      appState: {
        returnTo: window.location.pathname,
      },
    },
  }
);
